<template>
	<div class="about">
	  <div class="top-actions">
	  <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
	 
	  <el-button type="primary"size="small" icon="el-icon-plus" @click="handleAdd">添加</el-button>
		<el-button type="danger" size="small" icon="el-icon-delete"@click="handleDeleteSelected">删除</el-button>
		<el-button type="success"size="small"  @click="handleRunning">运行中</el-button>
		<el-button type="warning" size="small" @click="handlePaused">已暂停</el-button>
		<el-button type="info" size="small" @click="handleCompleted">已完成</el-button>
		<div class="search-container">
        <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
		<el-button type="default" icon="el-icon-search" @click="showSearchFields = !showSearchFields"></el-button>
	</div>
	  </div>
	  <div v-if="showSearchFields" class="advanced-search-fields">
  <el-row :gutter="20">
    <el-col :span="12">
      <el-form :model="searchForm" label-width="100px">
        <el-form-item label="任务ID">
          <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
        </el-form-item>
        <el-form-item label="任务名">
          <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="12">
      <el-form :model="searchForm" label-width="100px">
        <el-form-item label="采集源">
          <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="searchForm.creationTime" placeholder="请输入创建时间"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
  <el-button type="default" @click="handleAdvancedSearch">提交</el-button>
</div>
	  
	  <el-table
		ref="filterTable"
		:data="filteredTableData"
		:header-cell-style="{color:'#606266',background:'#f5f7fa'}"
		style="width: 100%"
		stripe
		border
		@selection-change="handleSelectionChange">
		<el-table-column type="selection" width="55"></el-table-column>
		<el-table-column prop="date" label="任务id" sortable width="180" column-key="date" :filters="[{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]" :filter-method="filterHandler"></el-table-column>
		<el-table-column prop="name" label="任务名" width="180"></el-table-column>
		<el-table-column prop="address" label="采集源" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="任务状态" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="时间筛选" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="意向客户数" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="线索视频数" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="今日消耗" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="定时截止" :formatter="formatter"></el-table-column>
		<el-table-column prop="address" label="创建时间" :formatter="formatter"></el-table-column>
		<!-- 其他列根据需要添加 -->
		<el-table-column label="操作">
		  <template slot-scope="scope">
			<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
			<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
		  </template>
		</el-table-column>
	  </el-table>
	  <div class="pagination">
		<el-pagination background layout="total, prev, pager, next" :current-page="currentPage" :page-size="pgSize" :total="filteredTableData.length" @current-change="handlePageChange"></el-pagination>
	  </div>
	  <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
		<el-form ref="form" :model="form" label-width="70px">
		  <el-form-item label="用户名">
			<el-input v-model="form.name"></el-input>
		  </el-form-item>
		  <el-form-item label="地址">
			<el-input v-model="form.address"></el-input>
		  </el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
		  <el-button @click="editVisible = false">取 消</el-button>
		  <el-button type="primary" @click="saveEdit">确 定</el-button>
		</span>
	  </el-dialog>
	</div>
  </template>
  
  <script>
  export default {
	data() {
	  return {
		currentPage: 1,
		pgSize: 4,
		idx: -1,
		editVisible: false,
		form: {},
		searchQuery: '',
		showSearchFields: false,
		searchForm: {
        taskId: '',
        taskName: '',
        collectionSource: '',
        creationTime: ''
      },
		selectedRows: [],
		tableData: [
		  // 这里是表格数据
		]
	  }
	},
	computed: {
	  filteredTableData() {
		return this.tableData.filter(data => {
		  return Object.values(data).some(value => {
			return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
		  });
		});
	  }
	},
	methods: {
	handleRefresh() {
      // Logic to refresh the data
      console.log('Refreshing data...');
    },
	  handleAdd() {
		// 添加新行的逻辑
	  },
	  handleDeleteSelected() {
		this.tableData = this.tableData.filter(row => !this.selectedRows.includes(row));
	  },
	  handleRunning() {
		// 运行中任务的逻辑
	  },
	  handlePaused() {
		// 已暂停任务的逻辑
	  },
	  handleCompleted() {
		// 已完成任务的逻辑
	  },
	  handleEdit(index, row) {
		this.idx = index;
		this.form = row;
		this.editVisible = true;
	  },
	  saveEdit() {
		this.editVisible = false;
		this.$message.success(`修改第 ${this.idx + 1} 行成功`);
		this.$set(this.tableData, this.idx, this.form);
	  },
	  handleDelete(index, row) {
		this.$confirm('确定要删除吗？', '提示', {
		  type: 'warning'
		}).then(() => {
		  this.$message.success('删除成功');
		  this.tableData.splice(index, 1);
		}).catch(() => {});
	  },
	  handlePageChange(val) {
		this.currentPage = val;
	  },
	  handleSelectionChange(selection) {
		this.selectedRows = selection;
	  },
	  resetDateFilter() {
		this.$refs.filterTable.clearFilter('date');
	  },
	  clearFilter() {
		this.$refs.filterTable.clearFilter();
	  },
	  formatter(row, column) {
		return row.address;
	  },
	  filterTag(value, row) {
		return row.tag === value;
	  },
	  filterHandler(value, row, column) {
		const property = column['property'];
		return row[property] === value;
	  },
	  handleSearch() {
		// 这个方法在搜索框输入变化时触发
	  },
	  handleAdvancedSearch() {
      // Logic to perform advanced search using searchForm data
      console.log('Advanced search:', this.searchForm);
      this.showSearchFields = false;
    },
	}
  }
  </script>
  
  <style lang="stylus">
  .top-actions
   display flex
   align-items center
   justify-content space-between
   margin-bottom 10px

  .search-container
   margin-left: auto
  
  .button-container
   margin-right: auto

  .advanced-search-fields {
	margin-bottom: 10px;
  }
  
  
  
  </style>